import styles from "../AudioRecorder.module.scss";

const RecordingTimer = ({
  recordingTimeString,
  isRecordingStarted,
  isPaused,
}) => (
  <div className={styles["audio-recorder__center-top"]}>
    <div
      className={`${styles["audio-recorder__timer"]} ${
        isRecordingStarted && isPaused && styles["recording-paused"]
      }`}
    >
      {recordingTimeString}
    </div>
  </div>
);

export default RecordingTimer;
